import { render, staticRenderFns } from "./LogoPlayer.vue?vue&type=template&id=40c05a26&"
import script from "./LogoPlayer.vue?vue&type=script&lang=js&"
export * from "./LogoPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports